(ns common.themes.sponsor-capital)

(def border-radiuses
  {:xxxsmall ".25rem"
   :xxsmall  ".5rem"
   :xsmall   ".625rem"
   :small    ".75rem"
   :medium   "1rem"
   :large    "2rem"
   :xlarge   "3rem"
   :round    "50%"})

(def border-widths
  {:medium "1px"
   :large  "2px"})

(def palette
  "Palette of colors for this theme.

  Names in comments correspond to names given in our palette:
  https://xd.adobe.com/view/033e9162-93f3-4a87-89b4-653e104188e3-566d/screen/92aecc9d-e9ad-4d4b-b630-f55c6fb62678/specs/"
  {:background              "#ded6cf"
   ;; Brand colors
   ;;#383e88 blue (navigation)
   ;;#2b2f68 darker blue (bg?)
   ;;#ff8282 orange -> key figures, font
   :brand-1                 "#a1a5da"
   :brand-2                 "#2b2f68"                                                               ;"#046A38"
   :brand-3                 "#ff8248"                                                               ;"#06555A"
   :brand-4                 "#383e88"                                                               ;"#06555A"
   :brand-5                 "#EDEEF7"                                                               ;"#06555A"
   :brand-6                 "#BDBDBD"
   :brand-7                 "#3968B1"

   ;; Gray scales
   :black                   "#2b2f68"
   :grey-80                 "#363636"                                                               ;; Black
   :grey-60                 "#565952"                                                               ;; Gray
   :grey-50                 "#888C81"                                                               ;; Light grey
   :grey-40                 "#A5A7CB"                                                               ;; Lighter grey
   :grey-30                 "#E0E1ED"                                                               ;; Off gray
   :grey-20                 "#F6F6FA"                                                               ;; Off-white
   :grey-10                 "#F8F8F8"                                                               ;; Off gray #2
   :white                   "#fff"                                                                  ;; Pure white
   ;; Complementary colors
   :info                    "#31B8C7"                                                               ;; Blue
   :success                 "#68C3A5"                                                               ;; Success
   :warning                 "#F5BD3E"                                                               ;; Orange
   :danger                  "#E86546"                                                               ;; Red
   :light                   "#ded6cf"
   :dark                    "#32332F"
   :blue-link               "#007BFF"
   :black-transparent       "#000000AA"
   :black-transparent-light "rgba(0,0,0,0.3)"
   ;;
   :transparent             "transparent"})

(def colors
  "Map of UI element keys to palette color keys. Function `(color […])` uses this map to retrieve
  a color key and fetches its hex value from the palette.
  - all UI element keys used in UI components MUST appear in this map
  - the color keys in this map MUST be defined in the palette"
  {:expansion-panel  {:border :grey-30}
   :alert            {:variant {:info    :info
                                :success :success
                                :warning :warning
                                :danger  :danger}
                      :border  :grey-30}
   :burger-menu      {:bg         :brand-1
                      :cross      :grey-80
                      :overlay    {:bg :black-transparent-light}
                      :menu       {:bg :white}
                      :item       {:link   :brand-4
                                   :border :grey-30}
                      :link       {:color :white}
                      :link-hover {:color :brand-2}}

   :link             {:primary   {:color :brand-4
                                  :hover :brand-3}
                      :secondary {:color       :brand-1
                                  :match       :warning
                                  :hover-color :white}
                      :main      {:color :grey-60}
                      :border    {:color :grey-40}}

   :text-strong      {:primary   {:color :grey-80}
                      :hover     {:color :brand-2}
                      :secondary {:color :brand-3}}

   :text             {:primary   {:color :grey-80}
                      :secondary {:color :grey-50}
                      :main      {:color :grey-70}}

   :menu-item        {:primary {:bg :grey-40}}

   :dropdown         {:bg    :white
                      :color :dark
                      :hover {:color :white
                              :bg    :brand-1}
                      :focus {:color :white
                              :bg    :brand-1}}

   :layout           {:col     {:right-border :grey-30}
                      :primary {:bg :grey-20}}
   :general-border   {:border          :grey-30
                      :border-strong   :grey-60
                      :border-hover    :brand-1
                      :border-selected :brand-1
                      :caret           :grey-60}

   :figure           {:primary {:color :brand-3}
                      :comment {:bg :grey-30}}

   :upload-file      {:primary {:color :grey-50}}

   :tablebg          {:primary {:bg :white}}

   :page-bg          {:bg :white}

   :outer-container  {:primary   {:bg :transparent}
                      :secondary {:bg :white}
                      :border    :grey-40}

   :entity-row       {:bg        :white
                      :border    :grey-30
                      :row       {:bg :transparent}
                      :sort-item {:border :grey-10}}

   :container-bgr    {:primary   {:bg :white}
                      :secondary {:bg :brand-5}
                      :helper    {:bg :brand-3}}

   :footer-bgr       {:secondary  {:bg :brand-4}
                      :separator  :white
                      :text-hover :grey-50
                      :text       :white}

   :header-bgr       {:primary   {:bg    :black
                                  :color :white}
                      :secondary {:bg    :transparent
                                  :color :black}}

   ;;PORTAL styles

   :sidebar-nav-link {:regular {:color  :brand-4
                                :bg     :white
                                :border :transparent}
                      :hover   {:color  :brand-3
                                :bg     :white
                                :border :brand-1}}

   :home-link        {:regular {:color  :brand-4
                                :hover  :brand-3
                                :bg     :white
                                :border :grey-30}
                      :back    {:hover   :brand-2
                                :default :brand-1}
                      :hover   {:color :brand-2}}

   ;;Editor styles

   :icon-step        {:regular {:color :grey-50}
                      :done    {:color :success}}

   :progress         {:default    {:bg :grey-30}
                      :active     {:bg :brand-1}
                      :activeText {:color :white}}

   :badge            {:primary           {:bg :brand-1
                                          :fg :white}
                      :secondary         {:bg :grey-60
                                          :fg :white}
                      :success           {:bg :success
                                          :fg :white}
                      :danger            {:bg :danger
                                          :fg :white}
                      :warning           {:bg :brand-1
                                          :fg :black}
                      :info              {:bg :info
                                          :fg :white}
                      :light             {:bg :grey-30
                                          :fg :black}
                      :dark              {:bg :brand-1
                                          :fg :white}
                      :new-investment    {:bg :transparent
                                          :fg :brand-2}
                      :portfolio-company {:bg :transparent
                                          :fg :brand-3}
                      :exited-investment {:bg :transparent
                                          :fg :brand-1}}
   :breadcrumb       {:link       :brand-1
                      :link-hover :brand-1}

   :button           {:disabled   {:link  {:bg :white
                                           :fg :grey-50}
                                   :other {:bg :grey-30
                                           :fg :white}}
                      :focus      {:other {:border :white}}
                      :regular    {:primary   {:bg :brand-1
                                               :fg :white}
                                   :secondary {:bg :brand-3
                                               :fg :white}
                                   :success   {:bg :success
                                               :fg :white}
                                   :danger    {:bg :danger
                                               :fg :white}
                                   :warning   {:bg :brand-1
                                               :fg :white}
                                   :info      {:bg :brand-2
                                               :fg :white}
                                   :light     {:bg :grey-30
                                               :fg :black}
                                   :dark      {:bg :brand-2
                                               :fg :white}
                                   :link      {:bg :white
                                               :fg :blue-link}
                                   :frame     {:bg :white
                                               :fg :brand-1}}
                      :nav-button {:bg        :brand-1
                                   :color     :white
                                   :secondary {:bg    :white
                                               :color :brand-1}
                                   }}

   :card             {:card {:box-shadow :grey-30
                             :bg         :background}
                      :head {:disabled :grey-30
                             :title    :brand-1}
                      :body {:border-top :grey-30
                             :border     :grey-30
                             :bg         :white
                             :link       {:regular :brand-2
                                          :hover   :brand-1}}}

   :content-card     {:body  {:bg     :white
                              :border :grey-20}
                      :row   {:border :grey-30}
                      :child {:primary   {:bg :white}
                              :secondary {:bg :grey-20}}
                      :title {:color :brand-4}}

   :checkbox         {:regular-label {:disabled :grey-50}
                      :custom-label  {:enabled  {:bg {:checked   :brand-1
                                                      :unchecked :grey-50}
                                                 :fg :black}
                                      :disabled {:bg :grey-50
                                                 :fg :black}}
                      :custom-handle {:bg :white}
                      :regular-icon  {:disabled {:fg :grey-50}
                                      :checked  {:fg :brand-1}
                                      :fg       :grey-50}
                      :text          {:custom {:fg :white}}}
   :file-input       {:file-status            {:bg :white}
                      :file-name              :grey-80
                      :progress-bar-container {:bg :grey-30
                                               :fg :white}
                      :progress-bar           {:bg :brand-1}
                      :file-input             {:fg     :grey-80
                                               :bg     :white
                                               :border :grey-30}
                      :file-input-icon        {:fg :grey-30}
                      :file-remove            {:fg    :grey-80
                                               :hover {:fg :danger}}}

   :text-input       {:border {:regular :grey-30
                               :hover   :grey-80
                               :focus   :grey-80}
                      :bg     :grey-20}
   :sub-header       {:border     :grey-40
                      :text       :brand-1
                      :title      :brand-1
                      :long-title :brand-1}
   :field-options    {:color  :black
                      :bg     :white
                      :item   {:bg     :white
                               :color  :black
                               :border :grey-30}
                      :header {:border :grey-30}}

   :modal-dialog     {:header        {:bg            :black
                                      :text          :white
                                      :border-bottom :grey-20
                                      :color         :white}
                      :footer        {:border-top :grey-20}
                      :modal         :black
                      :modal-content {:bg :white}}
   :radio-group      {:icon {:checked   :brand-1
                             :unchecked :grey-30}}
   :rich-text-editor {:wrapper {:border :grey-30}
                      :toolbar {:border-bottom :grey-30}}
   :search-input     {:border {:regular :grey-30
                               :hover   :grey-80
                               :focus   :grey-80}}
   :select-input     {:container           {:bg     :white
                                            :border :grey-30}
                      :input-container     {:bg :grey-10}
                      :group-heading       {:bg :grey-30}
                      :indicator-separator :grey-30
                      :loading-indicator   :grey-30
                      :loading-message     :grey-30
                      :menu                :white
                      :multi-value         {:border :brand-1
                                            :fg     :brand-1}
                      :no-options-message  {:border :grey-30}
                      :option              {:selected   {:border-top :grey-20
                                                         :bg         :brand-1
                                                         :fg         :white
                                                         :hover      {:bg :white
                                                                      :fg :brand-1}}
                                            :focused    {:border-top :grey-20
                                                         :bg         :grey-10
                                                         :fg         :brand-1}
                                            :border-top :grey-20}
                      :placeholder         {:fg :grey-50}
                      :deselect-button     {:bg :grey-25}}
   :sortable-list    {:drag-handle {:bg     :white
                                    :border :grey-30}}
   :steps-band       {:steps-band {:border :grey-30}
                      :step       {:fg          {:completed        :white
                                                 :completed-active :white
                                                 :active           :white
                                                 :next             :grey-80}
                                   :bg          {:completed        :black
                                                 :completed-active :black
                                                 :active           :brand-1
                                                 :next             :white}
                                   :border-left {:before :grey-30
                                                 :after  {:completed        :black
                                                          :completed-active :black
                                                          :active           :brand-1
                                                          :next             :white}}}
                      :step-icon  {:completed        {:bg :transparent
                                                      :fg :white}
                                   :completed-active {:bg :white
                                                      :fg :black}
                                   :active           {:bg :white
                                                      :fg :black}
                                   :next             {:bg :transparent
                                                      :fg :grey-80}}}
   :tab-layout       {:tab-title  {:regular  {:border-bottom :brand-2}
                                   :selected {:fg            :brand-1
                                              :border-bottom :brand-2}
                                   :text     {:default  :grey-60
                                              :selected :brand-1}
                                   :border   {:default  :transparent
                                              :selected :grey-60}}
                      :title-line {:border :transparent}}

   :dynamic-table    {:border      :grey-10
                      :heading     {:border :grey-10}
                      :cell        {:border :grey-10}
                      :title-cell  {:border :brand-2}
                      :th          {:border :brand-2}
                      :total       {:bg     :grey-30
                                    :border :brand-1}
                      :sub-total   {:bg :grey-40}
                      :blank       {:border :brand-1}
                      :bg          :grey-20
                      :heading-row {:bg :brand-1}
                      :odd-row     {:bg :white}
                      :even-row    {:bg :grey-20}}

   :news-section     {:general         {:bg    :brand-5
                                        :color :brand-4}
                      :dropdown        {:color      :brand-4
                                        :background :transparent
                                        :border     :brand-4
                                        :outline    :brand-1}
                      :dropdown-option {:color :white}
                      :show-all        {:default {:color :white}
                                        :hover   {:color :brand-2}}}

   :table            {:border :grey-30
                      :tr     {:even            :white
                               :odd             :grey-10
                               :subheading      :brand-4
                               :subheading2     :brand-5
                               :subheading-text :dark}
                      :th     {:bg            :brand-4
                               :fg            :white
                               :border-bottom :grey-20}}
   :chart            {:waterfall     {:line  :grey-60
                                      :start :grey-40
                                      :sum   :grey-50
                                      :up    :success
                                      :down  :warning
                                      :color :brand-1}
                      :x-axis        {:line      :grey-40
                                      :grid-line :grey-40}
                      :y-axis        {:line      :grey-40
                                      :grid-line :grey-40}
                      :line-chart    {:line            :brand-1
                                      :multi-primary   :grey-80
                                      :multi-secondary :grey-40}
                      :bar-chart     {:primary   :brand-1
                                      :secondary :brand-2
                                      :grid      {:line :grey-40}}
                      :locations-map {:marker {:bg   :white
                                               :line :black}}}
   :pdf              {:table        {:odd-color     :grey-20
                                     :even-color    :white
                                     :heading-color :brand-1
                                     :header-border :grey-20
                                     :border        :grey-40
                                     :raw-border    :grey-20
                                     :total-border  :grey-30
                                     :heading       {:text :white}
                                     :text          :grey-80}
                      :stack        {:label      :grey-80
                                     :value      :grey-80
                                     :value-list :grey-60}
                      :color        :grey-80
                      :footer       {:text :grey-40}
                      :color-dark   :grey-80
                      :heading      :grey-80
                      :border       :grey-30
                      :landing-page {:text :white}
                      :toc          {:text :grey-80}
                      :column       {:color :grey-80}
                      :fill         :grey-20
                      :text         {:h1   :brand-1
                                     :h2   :brand-1
                                     :h3   :brand-1
                                     :a    :brand-1
                                     :html :grey-80}}
   :lp-report        {:big-figures      {:pdf {:border  :grey-30
                                               :value   :dark
                                               :label   :dark
                                               :comment :brand-5}}
                      :chart            {:x-axis      {:line      :grey-40
                                                       :grid-line :grey-40}
                                         :y-axis      {:line      :grey-40
                                                       :grid-line :grey-40}
                                         :waterfall   {:sum   :brand-2
                                                       :up    :brand-1
                                                       :down  :brand-3
                                                       :color :success}
                                         :multi-chart {:ordered-default-colors {:color-1 :brand-1   ;; NOTE: can add more colors
                                                                                :color-2 :brand-4
                                                                                :color-3 :brand-5
                                                                                :color-4 :brand-1}}
                                         :map         {:highlighted-countries     {:color :brand-4}
                                                       :non-highlighted-countries {:color :brand-5}
                                                       :hover                     {:color :brand-3}
                                                       :label                     {:color :white}}}
                      :report-row       {:border       :grey-10
                                         :hover-border :brand-1
                                         :default      :grey-80}
                      :section          {:border  :brand-4
                                         :default :brand-4}

                      :table            {:font-color         :brand-4
                                         :even-row           {:bg :white}                           ;;NOTE use this for coloring all the tables, web and pdf
                                         :odd-row            {:bg :grey-20}
                                         :heading-color      {:bg :brand-4
                                                              :fg :white}
                                         :heading-info-color {:bg :brand-5}
                                         :subheading-color   {:bg :white}
                                         :subtotal-color     {:bg :white}
                                         :total-color        {:bg :white}
                                         :empty-line-color   {:bg :white}
                                         :pdf                {:even-row           {:bg :white}
                                                              :odd-row            {:bg :grey-10}
                                                              :heading-color      {:bg :brand-4
                                                                                   :fg :white}
                                                              :heading-info-color {:bg :grey-30}
                                                              :subheading-color   {:bg :white}
                                                              :subtotal-color     {:bg :white}
                                                              :total-color        {:bg :white}
                                                              :empty-line-color   {:bg :white}
                                                              :heading-border     :grey-20}}

                      :horizontal-table {:heading  {:background :white}
                                         :even-row {:bg :white}
                                         :odd-row  {:bg :grey-20}
                                         :pdf      {:even-row           {:bg :white}
                                                    :odd-row            {:bg :grey-20}
                                                    :heading-color      {:bg :brand-4}
                                                    :heading-info-color {:bg :brand-5}
                                                    :subheading-color   {:bg :white}
                                                    :subtotal-color     {:bg :white}
                                                    :total-color        {:bg :white}
                                                    :empty-line-color   {:bg :white}}}
                      :vertical-table   {:even-row {:bg :white}
                                         :odd-row  {:bg :grey-30}
                                         :pdf      {:even-row           {:bg :white}
                                                    :odd-row            {:bg :grey-20}
                                                    :heading-color      {:bg :brand-4}
                                                    :heading-info-color {:bg :brand-5}
                                                    :subheading-color   {:bg :white}
                                                    :subtotal-color     {:bg :white}
                                                    :total-color        {:bg :white}
                                                    :empty-line-color   {:bg :white}}}
                      :block-table      {:even-row {:bg :white}
                                         :odd-row  {:bg :grey-20}
                                         :pdf      {:even-row           {:bg :white}
                                                    :odd-row            {:bg :grey-20}
                                                    :heading-color      {:bg :brand-4}
                                                    :heading-info-color {:bg :brand-5}
                                                    :subheading-color   {:bg :white}
                                                    :subtotal-color     {:bg :white}
                                                    :total-color        {:bg :white}
                                                    :empty-line-color   {:bg :white}}}}
   :lp-portal        {:dashboard        {:pie-colors [:brand-1
                                                      :brand-2
                                                      :brand-3
                                                      :info
                                                      :success
                                                      :warning
                                                      :danger]}
                      :clickable        {:text {:default :brand-1
                                                :hover   :brand-3}}
                      :carousel         {:dot {:default {:border     :brand-1
                                                         :background :grey-40}
                                               :hover   {:border     :brand-2
                                                         :background :grey-30}}}
                      :promotion        {:text         :brand-4
                                         :card         {:bg :white}
                                         :card-shading :black-transparent
                                         :shading-text :white
                                         :link         :brand-1
                                         :link-hover   :brand-2
                                         :menu         {:dropdown {:bg :white}
                                                        :item     {:hover :grey-20}}}
                      :report-container {:border :grey-40}
                      :outer-container  {:border :grey-40}
                      :report           {:toolbar {:border :grey-40}}
                      :section          {:border :brand-1
                                         :title  {:default :brand-2}}
                      :card             {:body {:link   {:hover   :brand-2
                                                         :default :brand-1}
                                                :bg     :white
                                                :border :grey-10}
                                         :head {:title :brand-4}}
                      :table            {:cell   {:strong :grey-80}
                                         :border :grey-10}}
   :lp-editor        {:page             {:background     :white
                                         :data-watermark :light}
                      :header           {:background :transparent}
                      :step             {:icon {:done    :success
                                                :default :grey-50}}
                      :checkbox         {:checked :success}
                      :sidebar-nav-link {:default :brand-1
                                         :hover   :brand-2}
                      :upload           {:default      :grey-50
                                         :progress     :grey-30
                                         :uploading    :info
                                         :error        :danger
                                         :processing   :warning
                                         :complete     :success
                                         :progress-bar {:text       :white
                                                        :background :brand-1}}}
   :login            {:background-color :white}
   :app              {:field     {:label {:read-only :grey-50}
                                  :value {:read-only :grey-80}}
                      :card      {:label :grey-80}
                      :heading-1 :grey-80
                      :group     {:label :grey-80}
                      :risk-card {:background :grey-20
                                  :border     :grey-80}
                      :icon      {:clickable {:hover :brand-2}}}
   ;; Adding the palette keys so that one can access its colors with `(color [:palette :white]`)
   :palette          (->> palette
                          keys
                          (map (fn [k] [k k]))
                          (into {}))})
(def edge-sizes
  "Margins and paddings"
  {:xxxsmall "0.25rem"
   :xxsmall  "0.5rem"
   :xsmall   "0.75rem"
   :small    "1rem"
   :medium   "1.25rem"
   :large    "1.5rem"
   :xlarge   "1.875rem"
   :xxlarge  "2.5rem"
   :xxxlarge "3.125rem"})

(def font-weights
  {:regular   400
   :medium    500
   :semi-bold 600
   :bold      700})

(def font-families
  {:primary   "Open Sans"
   :secondary "Palatino LT Pro"})

(def text-sizes
  "text-size/size corresponds to CSS `font-size`
  text-size/height corresponds to CSS `line-height`"
  {:xxxsmall {:size   ".625rem"
              :height "1.4"}
   :xxsmall  {:size   ".75rem"
              :height "1.4"}
   :xsmall   {:size   ".875rem"
              :height "1.5"}
   :small    {:size   "1rem"
              :height "1.5"}
   :medium   {:size   "1.25rem"
              :height "1.5"}
   :large    {:size   "1.75rem"
              :height "1.6"}})

(def theme
  {:border-radiuses border-radiuses
   :border-widths   border-widths
   :colors          colors
   :edge-sizes      edge-sizes
   :font-weights    font-weights
   :palette         palette
   :text-sizes      text-sizes
   :font-families   font-families})


